import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { BrandBgActions } from "@youm-front/brand/data-access";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { RoomBrandBgActions } from "../actions";
import {
  RoomBrandBgCreateRequestDTO,
  RoomBrandBgDeleteRequestDTO,
  RoomBrandBgUnUseRequestDTO,
  RoomBrandBgUseRequestDTO
} from "../dto";
import { RoomBrandBgService } from "../services";

@Injectable()
export class RoomBrandBgEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly roomBrandBgService: RoomBrandBgService
  ) {}

  roomBrandBgCreate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandBgActions.roomBrandBgCreate),
      switchMap((_) =>
        this.roomBrandBgService
          .roomBrandBgCreate(
            new RoomBrandBgCreateRequestDTO({
              roomId: _.roomBrandBgCreateVO.value.roomId,
              brandId: _.roomBrandBgCreateVO.value.brandId,
              data: _.roomBrandBgCreateVO.value.data,
              width: _.roomBrandBgCreateVO.value.width,
              height: _.roomBrandBgCreateVO.value.height
            })
          )
          .pipe(
            mergeMap((_) => [
              RoomBrandBgActions.roomBrandBgCreateSuccess({
                brandBg: _.data.brandBg
              }),
              BrandBgActions.brandBgCreateSuccess({
                brandBg: _.data.brandBg
              })
            ]),
            catchError((_: Error) => [
              RoomBrandBgActions.roomBrandBgCreateFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );

  roomBrandBgDelete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandBgActions.roomBrandBgDelete),
      switchMap((_) =>
        this.roomBrandBgService
          .roomBrandBgDelete(
            new RoomBrandBgDeleteRequestDTO({
              roomId: _.roomBrandBgDeleteVO.value.roomId,
              brandBg: _.roomBrandBgDeleteVO.value.brandBg
            })
          )
          .pipe(
            mergeMap((_) => [
              RoomBrandBgActions.roomBrandBgDeleteSuccess({
                brandBg: _.data.brandBg
              }),
              BrandBgActions.brandBgDeleteSuccess({
                brandBg: _.data.brandBg
              })
            ]),
            catchError((_: Error) => [
              RoomBrandBgActions.roomBrandBgDeleteFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );

  roomBrandBgUnUse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandBgActions.roomBrandBgUnUse),
      switchMap((_) =>
        this.roomBrandBgService
          .roomBrandBgUnUse(
            new RoomBrandBgUnUseRequestDTO({
              roomId: _.roomBrandBgUnUseVO.value.roomId,
              brandBg: _.roomBrandBgUnUseVO.value.brandBg
            })
          )
          .pipe(
            mergeMap(() => [
              RoomBrandBgActions.roomBrandBgUnUseSuccess({
                brandBg: _.roomBrandBgUnUseVO.value.brandBg
              }),
              BrandBgActions.brandBgUnUseSuccess({
                brandBg: _.roomBrandBgUnUseVO.value.brandBg
              })
            ]),
            catchError((_: Error) => [
              RoomBrandBgActions.roomBrandBgUnUseFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );

  roomBrandBgUse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomBrandBgActions.roomBrandBgUse),
      switchMap((_) =>
        this.roomBrandBgService
          .roomBrandBgUse(
            new RoomBrandBgUseRequestDTO({
              roomId: _.roomBrandBgUseVO.value.roomId,
              brandBg: _.roomBrandBgUseVO.value.brandBg
            })
          )
          .pipe(
            mergeMap(() => [
              RoomBrandBgActions.roomBrandBgUseSuccess({
                brandBg: _.roomBrandBgUseVO.value.brandBg
              }),
              BrandBgActions.brandBgUseSuccess({
                brandBg: _.roomBrandBgUseVO.value.brandBg
              })
            ]),
            catchError((_: Error) => [
              RoomBrandBgActions.roomBrandBgUseFailure({
                error: _.message
              })
            ])
          )
      )
    )
  );
}
